import { Anchor } from "antd";

export default Anchor;